// extracted by mini-css-extract-plugin
module.exports = {"grid":"WeatherPage_grid__1CTpv","gridWeather":"WeatherPage_gridWeather__3EJF_"};